"use client";

import { ChevronDownIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { useMemo, useState } from "react";
import { getAllServices } from "@/lib/data";

const TRANSITION_CLASSES =
  "transition-opacity transition-transform duration-200 ease-out";

export default function SolutionsContextMenu() {
  const services = useMemo(
    () =>
      getAllServices().map(({ slug, name, shortDescription }) => ({
        slug,
        name,
        shortDescription,
      })),
    []
  );
  const [isOpen, setOpen] = useState(false);

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocusCapture={() => setOpen(true)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
          setOpen(false);
        }
      }}
    >
      <button
        className="text-neutral-400 transition-colors hover:text-yellow cursor-pointer inline-flex items-center gap-1 py-2 font-semibold"
        aria-haspopup="true"
        aria-expanded={isOpen}
        type="button"
        onClick={() => setOpen((prev) => !prev)}
      >
        Services
        <ChevronDownIcon
          width={16}
          height={16}
          className={`transition-transform duration-200 ${isOpen ? "rotate-180" : "rotate-0"}`}
        />
      </button>
      <div
        className={`absolute border border-border top-10 z-20 backdrop-blur-lg rounded-xl min-w-[320px] right-0 p-2 bg-background/95 shadow-xl ${TRANSITION_CLASSES} ${
          isOpen
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 -translate-y-2 pointer-events-none"
        }`}
        role="menu"
        aria-hidden={!isOpen}
      >
        <ul className="flex flex-col gap-2">
          {services.map((service) => (
            <li key={service.slug}>
              <Link
                href={`/services/${service.slug}`}
                className="block px-4 py-2 rounded-lg hover:bg-background/60 focus:bg-background/60 focus:outline-none transition-colors text-left"
              >
                <span className="text-lg font-medium text-white block">
                  {service.name}
                </span>
                <span className="text-xs font-light text-white/80 block">
                  {service.shortDescription}
                </span>
              </Link>
            </li>
          ))}
          <li className="border-t border-border pt-2 mt-2">
            <Link
              href="/broward-county-services"
              className="block px-4 py-2 rounded-lg hover:bg-background/60 focus:bg-background/60 focus:outline-none transition-colors text-yellow text-sm font-semibold"
            >
              View All Services by City →
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
